export default function ReportStruct(bool, selObject) {
    this.all = bool;
    this.selected = selObject;
}
